
import { parseJson, oz } from '@weft/utils';

export const INVOICE_REVIEW_STATUSES = Object.freeze({
  Draft: 'Draft',
  Approved: 'Approved',
  InReview: 'InReview',
  Synced: 'Synced',
});

export const InvoiceReviewStatusSchema = oz.nativeEnum(INVOICE_REVIEW_STATUSES).openapi('InvoiceReviewStatus');
export const InvoiceReviewStatusesSchema = oz.string()
  .transform(s => parseJson<InvoiceReviewStatus[]>(s))
  .pipe(InvoiceReviewStatusSchema.array()).optional();

export type InvoiceReviewStatus = oz.infer<typeof InvoiceReviewStatusSchema>;